import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  Form,
  Input,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { createComplaint } from "../../helpers/api/complaints";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import FalconCardHeader from "../common/FalconCardHeader";
import Flex from "../common/Flex";
import QuillEditor from "../common/QuillEditor";
import { PreloadState } from "../UI/preloading/PreloadState";
import { Toast } from "../UI/toast/Toast";

import ComposeAttachment from "./ComposeAttachment";
import { useSelector } from "react-redux";
import { fetchProperties } from "../../helpers/api/condominium";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";

let mounted = true;

const CreateComplaint = ({ setRedirect, setRedirectUrl }) => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [filess, setFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const fileRef = useRef(null);
  const [isDisabled, setIsDisabled] = useState(true);

  const [param, setParam] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const {
    data: data3,
    error: error3,
    isLoading: isLoading3,
    meta: meta3,
    handler: {
      goToPage: goToPage3,
      nextPage: nextPage3,
      perPage: perPage3,
      previousPage: previousPage3,
    },
  } = useSWRFetchPaginationProperty(fetchProperties, param);

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["clean"],
    ],
  };

  const handleAddAttachment = (files) => {
    if (files.length === 0) return;
    const { name, size, type } = files[0];
    const newFile = {
      id: attachments.length + 1 + Date.now(),
      name,
      size,
      type,
    };
    setFiles([...filess, files[0]]);
    setAttachments([...attachments, newFile]);
  };

  const handleDetachAttachment = (id, index) => {
    setAttachments(attachments.filter((attachment) => id !== attachment.id));
    setFiles(filess.filter((file, i) => i !== index));
  };

  useEffect(() => {
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setIsDisabled(!content || !title);
  }, [content, title]);

  console.log(filess.length);

  const makeComplaint = async (e) => {
    e.preventDefault();

    if (submitting) return;

    if (filess.length > 0) {
      setSubmitting(true);
      let form = new FormData();
      form.append("title", title);
      form.append("description", content);

      if (filess.length > 0) {
        filess.map((file, i) => form.append(`files[${i}]`, file));
      }

      createComplaint(form)
        .then(({ code }) => {
          if (code === SUCCESS_RESPONSE.CREATED) {
            Toast.fire({
              type: "success",
              title: `Publicación realizada exitosamente.`,
            });
            setRedirectUrl("/dashboard/complaints");
            setRedirect(true);
          }
        })
        .catch((error) => handleErrorMessage(error))
        .finally(() => mounted && setSubmitting(false));
    }

    if (filess.length === 0) {
      setSubmitting(true);
      let form = new FormData();
      form.append("title", title);
      form.append("description", content);

      if (filess.length > 0) {
        filess.map((file, i) => form.append(`files[${i}]`, file));
      }

      createComplaint(form)
        .then(({ code }) => {
          if (code === SUCCESS_RESPONSE.CREATED) {
            Toast.fire({
              type: "success",
              title: `Publicación realizada exitosamente.`,
            });
            setRedirectUrl("/dashboard/complaints");
            setRedirect(true);
          }
        })
        .catch((error) => handleErrorMessage(error))
        .finally(() => mounted && setSubmitting(false));
    }
  };

  return (
    <>
      <Alert color="primary" className="d-flex align-items-center shadow-sm">
        <FontAwesomeIcon icon={faExclamation} className="mr-4 ml-2" />
        <p className="mb-0">
          Tu sugerencia será enviada al administrador del condominio y será
          respondida en la brevedad posible.
        </p>
      </Alert>
      <Card tag={Form} onSubmit={makeComplaint}>
        <PreloadState
          loading={submitting}
          overlay
          message="Publicando por favor espere..."
        >
          <>
            <FalconCardHeader title="Nueva sugerencia" />
            <CardBody className="p-0">
              <div className="border-bottom border-200">
                <Input
                  type="text"
                  className="border-0 outline-none px-card"
                  value={title}
                  onChange={({ target }) => setTitle(target.value)}
                  placeholder="Título"
                />
              </div>
              <QuillEditor
                value={content}
                onChange={setContent}
                modules={modules}
                style={{ height: 300, marginBottom: 44 }}
              />
              <Input
                type="file"
                innerRef={fileRef}
                style={{ display: "none" }}
                onChange={({ target }) => handleAddAttachment(target.files)}
              />
              <div className="bg-light px-card py-3">
                <Flex column inline>
                  {attachments.map((attachment, i) => (
                    <ComposeAttachment
                      {...attachment}
                      key={attachment.id}
                      index={i}
                      handleDetachAttachment={handleDetachAttachment}
                    />
                  ))}
                </Flex>
              </div>
            </CardBody>
            <CardFooter
              tag={Flex}
              justify="between"
              className="border-top border-200"
            >
              <Flex align="center" justify="end">
                <Button
                  color="primary"
                  size="sm"
                  className="px-5 mr-2"
                  disabled={isDisabled || submitting}
                  type="submit"
                >
                  Enviar
                </Button>
                <Label
                  for="email-attachment"
                  className="mr-2 btn btn-light btn-sm mb-0 cursor-pointer"
                  id="AttachFiles"
                >
                  <FontAwesomeIcon icon="paperclip" className="fs-1" />
                </Label>
                <Input
                  className="d-none"
                  id="email-attachment"
                  type="file"
                  onChange={({ target }) => handleAddAttachment(target.files)}
                />
                <UncontrolledTooltip placement="top" target="AttachFiles">
                  Adjuntar archivos
                </UncontrolledTooltip>
              </Flex>
            </CardFooter>
          </>
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreateComplaint);
